<template>
    <div class="erm_form_wrapper">

        <div class="input-wrapper">
            <p class="form-label" for="name">Coupon Name *</p>
            <el-input class="erm_input" v-model="coupons.name" style="width: 100%"
                placeholder="Please Input Name" size="large" />
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ coupon_name_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name"> Coupon Code *</p>
            <el-input class="erm_input" v-model="coupons.code" style="width: 100%"
                placeholder="Please Input Code" size="large" />
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ code_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Discount Type *</p>
            <el-select class="erm_input" v-model="coupons.discount_type" placeholder="Category Name" size="large"
                style="width: 100%">
                <el-option value="Percentage" />
                <el-option value="Fixed" />
            </el-select>
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ discount_type_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name"> Discount Amount *</p>
            <el-input class="erm_input" v-model="coupons.discount_value" style="width: 100%"
                placeholder="Please Input Category Name" size="large" type="number" />
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ discount_value_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Status *</p>
            <el-select class="erm_input" v-model="coupons.status" placeholder="Input status " size="large"
                style="width: 100%;  margin-bottom: 20px;">
                <el-option value="Active" />
                <el-option value="Inactive" />
                <el-option value="Expired" />
                <el-option value="Upcoming" />
                <el-option value="Disabled" />
                <el-option value="Used" />
            </el-select>
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ status_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Added Date *</p>
            <el-date-picker class="erm_input"  v-model="coupons.added_date" type="date" style="width: 100%"
            placeholder="Start Date " size="large" />
                <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ added_date_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Expiration Date *</p>
            <el-date-picker class="erm_input"  v-model="coupons.expiration_date" type="date" style="width: 100%"
            placeholder="Start Date " size="large" />
                <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ expiration_date_error }}</p>
        </div>

       

        <div class="input-wrapper" @click="saveCategory()">
            <el-button size="large" type="primary">Save Coupon</el-button>
        </div>

    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            coupons: {
                name: "",
                code: "",
                discount_type: "",
                discount_value: "",
                status: "",
                expiration_date: "",
                added_date: "",
            },
            coupon_name_error: "",
            code_error: "",
            discount_type_error: "",
            discount_value_error: "",
            status_error: "",
            expiration_date_error: "",
            added_date_error: "",
            rest_api: window.RestaurantMenuMangeData.rest_api,
        };
    },
    props: {
        coupons_data: {
            type: Object,
        }
    },
    watch: {
        coupons_data: {
            handler: function (val) {
                this.coupons = val;
            },
            deep: true
        }
    },

    methods: {
        async saveCategory() {
            this.coupon_name_error = "";
            this.code_error = "";
            this.discount_type_error = "";
            this.discount_value_error = "";
            this.status_error = "";
            this.expiration_date_error = "";
            this.added_date_error="";
            if (!this.coupons.name) {
                this.coupon_name_error = "Coupon name is required";
                return;
            }
            if (!this.coupons.code) {
                this.code_error = "Coupon code is required";
                return;
            }
            if (!this.coupons.discount_type) {
                this.discount_type_error = "Coupon discount type is required";
                return;
            }
            if (!this.coupons.discount_value) {
                this.discount_value_error = "Coupon discount amount is required";
                return;
            }
            if (!this.coupons.status) {
                this.status_error = "Coupon status is required";
                return;
            }
            if (!this.coupons.expiration_date) {
                this.expiration_date_error = "Coupon expiration date is required";
                return;
            }
            if (!this.coupons.added_date) {
                this.added_date_error = "Coupon added date is required";
                return;
            }
            try {
                const response = await axios.post(`${this.rest_api}/postCoupon`, {
                    data: this.coupons,
                    name: this.coupons.name,
                    code : this.coupons.code ,
                    discount_type: this.coupons.discount_type,
                    discount_value : this.coupons.discount_value ,
                    expiration_date : this.coupons.expiration_date ,
                    added_date : this.coupons.added_date ,
                    status : this.coupons.status,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'easyRestaurantManager-nonce': window.RestaurantMenuMangeData.nonce,
                    }
                });
                console.log('Category:', response.data);
                this.$emit("updateDataAfterNewAdd", this.coupons);
                this.coupons = { name: "", brunch_id: "", description: "" };
                
            } catch (error) {
                console.error('Error fetching coupon:', error);
            }
        },


    },
    mounted() {
        if (this.coupons_data) {
            console.log('Coupons:', this.coupons_data);
            this.coupons = this.coupons_data;
        }
    }

};
</script>